import { useState } from 'react';
import StringConstants from '@common/constants/StringConstants';
import errorMessages from '@common/constants/errorMessages';
import { Anchor, FormField, FormHelp, Input, Label } from '@zillow/constellation-10';

type Props = {
  error?: string;
  setVerificationCode: (val: string) => void;
};

const CODE_LENGTH = 5;

/* A single field instead of one box per digit: SMS autofill only works on one
   autoComplete="one-time-code" input, and it keeps paste and screen readers working. */
const PhoneVerificationInput = ({ error = '', setVerificationCode }: Props): JSX.Element => {
  const [code, setCode] = useState('');

  const updateInput = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const nextCode = e.target.value.replace(/[^\d]/g, '').slice(0, CODE_LENGTH);
    setCode(nextCode);
    setVerificationCode(nextCode);
  };

  const errorMessage =
    error === errorMessages.PHONE_VERIFICATION_TOO_MANY_ATTEMPTS ? (
      <span>
        Too many attempts have been made.{' '}
        <Anchor target="_blank" href={StringConstants.LINKS.SUPPORT_PAGE.LANDLORD}>
          Contact support
        </Anchor>{' '}
        to continue.
      </span>
    ) : (
      error
    );

  return (
    <FormField
      // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 36rem` is past the end of the numeric sizes scale, which stops at `5000` (200px)
      css={{ maxWidth: '36rem' }}
      required
      error={Boolean(error)}
      label={<Label>5-digit code</Label>}
      control={
        <Input
          value={code}
          onChange={updateInput}
          inputMode="numeric"
          autoComplete="one-time-code"
          className="fs-exclude"
          autoFocus
        />
      }
      description={error ? <FormHelp role="alert">{errorMessage}</FormHelp> : undefined}
    />
  );
};

export default PhoneVerificationInput;
